<template>
  <div class="h100-40">
      <ImportObserveTableMenu :isImport="isImport" @methodEnum="methodEnum"></ImportObserveTableMenu>
      <div class="h-track-flexContent h-track-flexRow">
        <div id="observeTable" class="h100vh-180 h-track-flexItem">
          <ImportObserveTable ref="importObserveTable" :isImport="isImport"></ImportObserveTable>
        </div>
      </div>
      <div class="h100vh-180 h-track-w35rem h-track-borTop"></div>
    </div>
</template>
<script>
import ImportObserveTableMenu from "./ImportObserveTableMenu";
import ImportObserveTable from "./ImportObserveTable";
export default {
  name: "ImportObserveList",
  props: {
    isImport: { type: Boolean, default: false }
  },
  components: { ImportObserveTableMenu, ImportObserveTable },
  data() {
    return {
      // panelContent() {
      //   return {
      //     template: ImportObserveTable
      //   };
      // }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case "import":
          this.$refs.importObserveTable.importTrackFunc();
          break;
        case "export":
          this.$refs.importObserveTable.exportTrackFunc();
          break;
        case "search":
          this.$refs.importObserveTable.searchTask();
          break;
        case "active":
          this.$refs.importObserveTable.activeObservePage();
          break;
        case "hangup":
          this.$refs.importObserveTable.hangupObservePage();
          break;
        case "finish":
          this.$refs.importObserveTable.finishObservePage();
          break;
        default:
      }
    }
  },
  beforeMount() {
    const observeNowTab = JSON.parse(localStorage.getItem("observeNowTab"));
    console.log("observeNowTab", observeNowTab);
    if (observeNowTab.type === "Import") {
      this.isImport = true;
    }
  }
};
</script>